export default __webpack_public_path__ + "static/char-v-08-71f490433b49a3b62c85f78e7df16937.mp4";